export default {
  // 文字列の配列から Vue で利用可能なオブジェクト構文に変換する
  // @param {Array} arr
  arrayToClassObject(arr) {
    if (!arr) {
      return {};
    }
    return arr.reduce(function (o, c) {
      o[c] = true;
      return o;
    }, {});
  },
  classObjectToArray(obj) {
    if (!obj) {
      obj = {};
    }
    const result = [];
    for (let key of Object.keys(obj)) {
      if (obj[key]) {
        result.push(key);
      }
    }
    return result;
  }
};
